import { DatePipe } from '@angular/common';
import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { StripeCardElementOptions } from '@stripe/stripe-js';
import { StripeCardNumberComponent, StripeService } from 'ngx-stripe';
import { ConstantsService } from 'src/app/services/constants.service';
import { DataService } from 'src/app/services/data.service';
import { UrlConstants } from 'src/app/services/url-constants';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-all-access',
  templateUrl: './all-access.component.html',
  styleUrls: ['./all-access.component.scss']
})
export class AllAccessComponent implements OnInit {
  @ViewChild(StripeCardNumberComponent) card: any = StripeCardNumberComponent;
  stripeCustomerId: any;
  amount: any = 0;
  planType : string = '';
  showconfirmModal: boolean = false;
  isRemoving: boolean = false;
  public cardOptions: StripeCardElementOptions = this.constants.SRIPE_CARD_STYLE;
  cardNumber: any;
  subscriptionId: any;
  subscriptionEnds: any;
  customer: any;
  success: any = null;
  isSkeltonLoad = true;
  skeltonArray: any = [{}];
  cardisChanging: boolean = false;
  cancelled = false;
  isloading = false;
  routeToPayment: boolean = false;
  screenHeight: number;
  screenWidth: number;
  windowWidth: string;
  @HostListener('window:resize', ['$event'])
  onResize() {
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;
    if (this.screenWidth <= 658 && this.screenWidth < this.screenHeight) {
      this.windowWidth = `calc(${this.screenHeight}px - 100px )`;
    }
  }
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private stripeService: StripeService,
    private dataService: DataService,
    private urlConstants: UrlConstants,
    public userService: UserService,
    public constants: ConstantsService, public datepipe: DatePipe
  ) { }

  ngOnInit(): void {
    this.authcall();
    this.onResize();
  }
  addnewcard() {
    this.router.navigate(['/user-setting/change-payment-method']), { relativeTo: this.route };
  }
  async listCard() {
    const params = [
      { param: '{actionName}', value: 'getCardDetails' }
    ]
    const postdata = {
      "stripe_customer_id": this.stripeCustomerId
    }
    await this.dataService.postData(this.urlConstants.getUri(this.urlConstants.action, params), postdata)
      .subscribe(async (data) => {
        if (this.customer !== undefined) {
          await data['res'].data.forEach(element => {
            if (this.customer.default_source === element.id) {
              element['selected'] = true;
            }
          });
        }
        await data['res'].data.forEach(element => {
          this.constants.CARD_IMG.forEach(img => {
            if (element.brand === img.brand) {
              element['brand_img'] = img.img;
            }
          });
        });

        this.cardNumber = await data['res'].data;
        this.isSkeltonLoad = false;
      }, err => {
        // console.log(err);
      })
  }
  async getStripeCustomer() {
    const params = [
      { param: '{actionName}', value: 'retriveCustomer' }
    ]
    const postdata = {
      "stripe_customer_id": this.stripeCustomerId
    }
    await this.dataService.postData(this.urlConstants.getUri(this.urlConstants.action, params), postdata)
      .subscribe(async (data) => {
        this.customer = data['res'];
        this.listCard();
      }, err => {
        // console.log(err);
      })
  }
  async getSubscriptionDetails() {
    const params = [
      { param: '{actionName}', value: 'SubscriptionDetails' }
    ]
    const postdata = {
      "subscriptionId": this.subscriptionId
    }
    await this.dataService.postData(this.urlConstants.getUri(this.urlConstants.action, params), postdata)
      .subscribe(async (data) => {
        let endDate;
        endDate = this.calculateDiff(data['res'].current_period_end);
        if (endDate < 0) {
          this.cancelled = true;
          this.routeToPayment = true;
        }
        else this.subscriptionEnds = this.datepipe.transform(data['res'].current_period_end, 'dd/MM/yyyy');
        if (data['res'].cancel_at_period_end) this.cancelled = true;
        else this.cancelled = false;

      }, err => {
        // console.log(err);
      })
  }
  calculateDiff(dateSent) {
    let currentDate = new Date();
    dateSent = new Date(dateSent);

    return Math.floor((Date.UTC(dateSent.getFullYear(), dateSent.getMonth(), dateSent.getDate()) - Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate())) / (1000 * 60 * 60 * 24));
  }
  async authcall() {
    await this.userService.getUser(false).then(res => {
      this.stripeCustomerId = res.stripe_customer_id;
      this.amount = res?.prime?.amount;
      if(this.amount == this.constants.PRICE_RATES.MONTHLY_RATE){
        this.planType = this.constants.PLAN_TYPE.MONTHLY
      }else if (this.amount == this.constants.PRICE_RATES.YEARLY_RATE1 || this.constants.PRICE_RATES.YEARLY_RATE2){
        this.planType = this.constants.PLAN_TYPE.YEARLY
      }
      this.subscriptionId = res.subscriptionId;
      this.getStripeCustomer();
      this.getSubscriptionDetails();
    })
  }
  async changeDefaultCard(data) {
    this.cardisChanging = true;
    const params = [
      { param: '{actionName}', value: 'setDefaultCard' }
    ]
    const postdata = {
      "stripe_customer_id": this.stripeCustomerId,
      "card_ele": data.id,
    }
    await this.dataService.postData(this.urlConstants.getUri(this.urlConstants.action, params), postdata)
      .subscribe(async (data) => {
        this.success = true;
        this.getStripeCustomer();
        this.cardisChanging = false;
        setTimeout(() => {
          this.success = null;
        }, 5000);
      }, err => {
        // console.log(err);
        this.success = false;
        setTimeout(() => {
          this.success = null;
        }, 5000);
      })

  }
  onClickCloseConfirmPopup() {
    this.showconfirmModal = false;
  }
  openConfirmModal() {
    this.showconfirmModal = true;
  }
  async cancelSubscription() {
    this.isRemoving = true;
    const params = [
      { param: '{actionName}', value: 'cancelSubscription' }
    ]
    const postdata = {
      "subscriptionId": this.subscriptionId,
      "cancel_at_period_end": true
    }
    await this.dataService.postData(this.urlConstants.getUri(this.urlConstants.action, params), postdata)
      .subscribe(async (data) => {
        this.success = true;
        this.isRemoving = false;
        this.showconfirmModal = false;
        if (data['res'].cancel_at_period_end) this.cancelled = true;
        setTimeout(() => {
          this.success = null;
        }, 5000);
      }, err => {
        this.success = false;
        this.isRemoving = false;
        this.showconfirmModal = false;
        setTimeout(() => {
          this.success = null;
        }, 5000);
        // console.log(err);
      })
  }
  async renewSubscription() {
    if (!this.routeToPayment) {
      this.isRemoving = true;
      this.isloading = true;
      const params = [
        { param: '{actionName}', value: 'cancelSubscription' }
      ]
      const postdata = {
        "subscriptionId": this.subscriptionId,
        "cancel_at_period_end": false
      }
      await this.dataService.postData(this.urlConstants.getUri(this.urlConstants.action, params), postdata)
        .subscribe(async (data) => {
          this.isloading = false;
          this.success = true;
          this.isRemoving = false;
          this.showconfirmModal = false;
          if (data['res'].cancel_at_period_end) this.cancelled = true;
          else this.cancelled = false;
          setTimeout(() => {
            this.success = null;
          }, 5000);
        }, err => {
          this.isloading = false;
          this.success = false;
          this.isRemoving = false;
          this.showconfirmModal = false;
          setTimeout(() => {
            this.success = null;
          }, 5000);
          // console.log(err);
        })
    } else {
      this.router.navigate(['/pricing'])
    }
  }
}
